__turbopack_context__.v({
  "sorts": "sorts-component-module-scss-module__i6F6lW__sorts",
  "sorts__sort-option": "sorts-component-module-scss-module__i6F6lW__sorts__sort-option",
});
